import AutenticacaoService from "@/common/services/autenticacao/autenticacao.service";
import JwtService from "@/common/utils/jwt";

export const VERIFICAR_AUTENTICACAO = "verificarAunteticacao";
export const LOGIN = "login";
export const LOGOUT = "logout";
export const LIMPAR_DADOS_AUTENTICACAO = "limparDadosAutenticacao";
export const SALVAR_DADOS_AUTENTICACAO = "salvarDadosAuntenticacao";
export const REGERAR_TOKEN_POR_EMPRESA = 'regerarTokenPorEmpresa';

const state = {
  erros: null,
  user: {},
  estaLogado: !!JwtService.buscarToken(),
};

const getters = {
  usuarioLogado(state) {
    return state.usuario;
  },
  estaLogado(state) {
    return state.estaLogado;
  },
};

const actions = {
  async [LOGIN](context, form) {
    return await AutenticacaoService.logar(form).then(async (result) => {
      context.commit(SALVAR_DADOS_AUTENTICACAO, result.data.data);
    });
  },
  async [LOGOUT](context) {
    /*const _token = JwtService.buscarToken();
    return await AutenticacaoService.invalidarToken(_token).then(async (result) => {
      if (result.data.success) {*/
        context.commit(LIMPAR_DADOS_AUTENTICACAO, context);
      /*}
    });*/
  },
  async [VERIFICAR_AUTENTICACAO](context) {
    const _token = JwtService.buscarToken();
    if (_token === null || _token === undefined) {
      context.commit(LIMPAR_DADOS_AUTENTICACAO, context);
      return;
    }

    return await AutenticacaoService.validarToken(_token)
      .then(async (result) => {
        if (result.data.data.valido && result.data.data.valido == false) {
          context.commit(LIMPAR_DADOS_AUTENTICACAO);
        }
        let claims = result.data.data.claims;
        localStorage.setItem("claims", JSON.stringify(claims));
      })
      .catch((err) => {
        try{
          if (!err.response) context.commit(LIMPAR_DADOS_AUTENTICACAO, context);
          if (!err.response.status) context.commit(LIMPAR_DADOS_AUTENTICACAO, context);
          if (err.response.status == 401) context.commit(LIMPAR_DADOS_AUTENTICACAO, context);
          if (err.response.status == 400) context.commit(LIMPAR_DADOS_AUTENTICACAO, context);
        }catch(e){
          context.commit(LIMPAR_DADOS_AUTENTICACAO, context);
        }
      });
  },
  async [REGERAR_TOKEN_POR_EMPRESA](context, form) {

    return await AutenticacaoService.regeraTokenPorEmpresa(form)
    .then(async (result) => {
      JwtService.salvarToken(result.data.data.accessToken);
    }).catch((err) => {
      console.error('Erro na chamada à API:', err);
    });
  }
};

const mutations = {
  [SALVAR_DADOS_AUTENTICACAO](state, usuario) {
    state.estaLogado = true;
    state.usuario = usuario;
    state.errors = {};
    if (usuario.accessToken) JwtService.salvarToken(usuario.accessToken);
    if (usuario.nome) JwtService.salvarNome(usuario.nome);
    if (usuario.email) JwtService.salvarEmail(usuario.email);
    if (usuario.id) JwtService.salvarId(usuario.id);
  },
  [LIMPAR_DADOS_AUTENTICACAO](state, context) {
    state.estaLogado = false;
    state.usuario = {};
    state.errors = {};
    
    JwtService.excluirToken();
    JwtService.excluirNome();
    JwtService.excluirSobrenome();
    JwtService.excluirEmail();
    JwtService.excluirId();

    localStorage.removeItem("selectedCompany");
    localStorage.removeItem("usuario_token");
    localStorage.removeItem("selectedCompanyObj");
    localStorage.removeItem("usuario_id");

    context.commit("app/removerUserInfo");
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
